import apiClient from "../apiClient";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const SubcategoriesAdd = () => {
    const [categories, setCategories] = useState([]);
    const sortedCategories = useMemo(
        () => [...categories].sort((a, b) => (a.Description || "").localeCompare(b.Description || "")),
        [categories]
    );

    useEffect (() => {
        const fetchAllCategories = async () => {
            try {
                const res = await apiClient.get("/categories");
                const rows = Array.isArray(res.data) ? res.data : [];
                const sorted = [...rows].sort((a, b) => (a.Description || "").localeCompare(b.Description || ""));
                setCategories(sorted);
                if (sorted.length > 0) {
                    setValues((prev) => ({ ...prev, CategoryId: sorted[0].CategoryId }));
                }
            } catch (err) {
                console.log(err);
            }
        };
        fetchAllCategories();

    }, []);

const [values, setValues] = useState({
    CategoryId: "",
    Description: "",
    });

const [error, setError] = useState(false)

const navigate = useNavigate();

const handleChange = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

const handleClick = async(e) => {
    e.preventDefault();
    if (!values.CategoryId || !values.Description?.trim()) return setError(true);
    try {
        await apiClient.post("/subcategories", values);
        navigate("/Subcategories");
    } catch (err) {
        console.log(err);
        setError(true)
    }
    };
    

    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Add Subcategory</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Subcategories">Subcategories</Link> / Add</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="subcategory-category">Category</label>
                    <select id="subcategory-category" name="CategoryId" onChange={handleChange} value={values.CategoryId}>
                        {sortedCategories.map((category) => (
                            <option key={category.CategoryId} value={category.CategoryId}>{category.Description}</option>
                        ))}
                    </select>

                    <label htmlFor="subcategory-description">Subcategory Description</label>
                    <input
                        id="subcategory-description"
                        type="text"
                        placeholder="Subcategory Description"
                        name="Description"
                        value={values.Description}
                        onChange={handleChange}
                    />
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Add Subcategory</button>
                        <Link className="btn-link" to="/Subcategories">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not save subcategory. Check input and try again.</p>}
                </div>
            </section>
        </div>

         );
    };

export default SubcategoriesAdd;
